import {
  isEmailVerified,
  useFirebaseAuthUserContext,
} from '@libraries/firebase';
import { Loading } from '@shared';
import { getRedirectPath } from '@utils';
import { useRouter } from 'next/router';
import { VerifyEmailMessage } from '../components/VerifyEmailMessage';

interface GuestGuardProps {
  children: React.ReactNode;
}

/** Blocks a component from rendering unless the user is signed out. */
export function GuestGuard({ children }: GuestGuardProps) {
  const { isLoading, user } = useFirebaseAuthUserContext();
  const router = useRouter();
  const redirectTo = getRedirectPath(router);

  if (isLoading) {
    return <Loading />;
  }

  if (user && !isEmailVerified(user)) {
    return <VerifyEmailMessage redirectTo={redirectTo} user={user} />;
  }

  if (user) {
    router.push(redirectTo);

    return null;
  }

  return <>{children}</>;
}
